import { Component, OnInit } from "@angular/core";
import { PopupService } from "../../shared/services/popup/popup.service";

@Component({
  selector: 'how-it-works',
  templateUrl: './how-it-works.component.html',
  styleUrls: ['./how-it-works.component.css']
})
export class HowItWorksComponent implements OnInit {

  constructor(private popupService: PopupService) {
  }
  ngOnInit() {
  }

  openloginFormDialog(): void {
    this.popupService.openLogin();
  }
}

